import { SearchTesterScreen } from "@commerce/catalog/SearchTesterScreen";
import { searchTesterSchema } from "@commerce/catalog/search-params";
import { LoadingRegion } from "@commerce/components/page";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { orpc } from "@shared/lib/orpc";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/search",
)({
	validateSearch: searchTesterSchema,
	shouldReload: false,
	loader: async ({ context }) => {
		const organizationId = context.organization.id;
		const queryClient = getServerQueryClient();
		await queryClient.ensureQueryData(
			orpc.catalog.overview.queryOptions({ input: { organizationId } }),
		);
		return {
			organizationId,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({ meta: [{ title: `Search tester - ${config.appName}` }] }),
	component: SearchPage,
});

function SearchPage() {
	const { organizationId, dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={
				<LoadingRegion
					label="Loading search tester"
					className="min-h-[50svh]"
				/>
			}
			dehydratedState={dehydratedState}
		>
			<SearchTesterScreen organizationId={organizationId} />
		</AsyncBoundary>
	);
}
